import { Controller } from "@hotwired/stimulus"

// Toggle between obscured and full email display
export default class extends Controller {
  static targets = ["obscured", "full", "showText", "hideText", "button"]

  toggle() {
    const isHidden = this.obscuredTarget.classList.contains("hidden")

    this.obscuredTarget.classList.toggle("hidden", !isHidden)
    this.fullTarget.classList.toggle("hidden", isHidden)
    this.showTextTarget.classList.toggle("hidden", !isHidden)
    this.hideTextTarget.classList.toggle("hidden", isHidden)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-label", isHidden ? "Show email" : "Hide email")
    }
  }
}
